"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _StandardIconWrapper = _interopRequireDefault(require("./StandardIconWrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var DisconnectIcon =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(DisconnectIcon, _React$PureComponent);

  function DisconnectIcon() {
    _classCallCheck(this, DisconnectIcon);

    return _possibleConstructorReturn(this, _getPrototypeOf(DisconnectIcon).apply(this, arguments));
  }

  _createClass(DisconnectIcon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          color = _this$props.color,
          className = _this$props.className,
          props = _objectWithoutProperties(_this$props, ["color", "className"]);
      /* eslint-disable max-len */


      return _react.default.createElement(_StandardIconWrapper.default, _extends({
        className: (0, _classnames.default)(className, 'disconnect-icon')
      }, props), _react.default.createElement("path", {
        fill: color,
        d: "M2.22794495,5.519973 C2.42296201,5.32397218 2.74098984,5.32397218 2.93700699,5.519973 L2.93700699,5.519973 L6.48131712,9.06398777 C6.67633418,9.25898858 6.67633418,9.5769899 6.48131712,9.77299072 L6.48131712,9.77299072 L6.12628605,10.1269922 C5.16920231,11.0829962 3.73307664,11.2479969 2.59697724,10.6449944 L2.59697724,10.6449944 L1.49888115,11.7439989 C1.3268661,11.9159996 1.10184641,12 0.876826722,12 C0.652807121,12 0.427787431,11.9159996 0.25577238,11.7439989 C-0.08525746,11.4009975 -0.08525746,10.8449952 0.25577238,10.5019938 L0.25577238,10.5019938 L1.35586864,9.40398918 C0.751815784,8.26698445 0.915830135,6.83197847 1.87391397,5.87397447 L1.87391397,5.87397447 Z M10.503369,0.257251072 C10.845399,-0.0857503573 11.4014476,-0.0857503573 11.7434776,0.257251072 C12.0855075,0.600252501 12.0855075,1.15525481 11.7434776,1.49825624 L11.7434776,1.49825624 L10.6543823,2.58826078 C11.257435,3.72426552 11.0944208,5.1602715 10.137337,6.11727549 L10.137337,6.11727549 L9.78230595,6.47227697 C9.5862888,6.66727778 9.26826097,6.66727778 9.07324391,6.47227697 L9.07324391,6.47227697 L8.80722063,6.20627586 L7.86613829,7.14927979 C7.62111685,7.3922808 7.22208193,7.3922808 6.98006076,7.14927979 C6.73503932,6.90327876 6.73503932,6.50627711 6.97906067,6.26127609 L6.97906067,6.26127609 L7.9211431,5.31927216 L6.68103459,4.080267 L5.73995225,5.02227093 C5.49493081,5.26427193 5.09689598,5.26427193 4.85287463,5.02227093 C4.60885327,4.77726991 4.60885327,4.37926825 4.85287463,4.13526723 L4.85287463,4.13526723 L5.79495706,3.19326331 L5.52893378,2.9282622 C5.33291663,2.73226138 5.33291663,2.41426006 5.52893378,2.21925925 L5.52893378,2.21925925 L5.88396485,1.86425777 C6.84104859,0.90725378 8.27617417,0.744253101 9.41327366,1.34725561 L9.41327366,1.34725561 Z"
      }));
      /* eslint-enable max-len */
    }
  }]);

  return DisconnectIcon;
}(_react.default.PureComponent);

exports.default = DisconnectIcon;
DisconnectIcon.defaultProps = {
  color: 'inherit'
};
DisconnectIcon.propTypes = {
  className: _propTypes.default.string,
  color: _propTypes.default.string
};